// extracted by mini-css-extract-plugin
export default {"showDesktop":"PropertiesModal_showDesktop__5iQhN","showMobile":"PropertiesModal_showMobile__w6nDZ"};